import { render, staticRenderFns } from "./MaterialCheckbox.vue?vue&type=template&id=3eee8e11&"
import script from "./MaterialCheckbox.vue?vue&type=script&lang=js&"
export * from "./MaterialCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports